<template>
  <card
    title="סיכום חודשי"
    :loading="loading"
    :error="error"
    :chart="chart"
  />
</template>

<script>
import { format } from "date-fns";
import { getApi } from "@/api";
import Card from "./Card.vue";

export default {
  data() {
    return {
      timeUnit: "month",
      fromDate: new Date("2018-06-01"),
      toDate: new Date(),
      loading: false,
      error: false,
      items: []
    };
  },

  methods: {
    format,
    fetchData() {
      this.loading = true;
      getApi()
        .then(api => {
          let params = {
            fromDate: this.fromDate,
            toDate: this.toDate,
            timeUnit: this.timeUnit,
          };
          return api.get("/reports/orders", { params });
        })
        .then(({ data }) => {
          this.items = data;
        })
        .catch(err => {
          console.log(err);
          this.error = true;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },

  computed: {
    xAxisData() {
      if (this.items) {
        return this.items.map(item => item.date );
      }
      return [];
    },
    maxIncome() {
      return (Math.max(...this.incomeData) || 1000000) * 1.2;
    },
    maxOrders() {
      return (Math.max(...this.ordersData) || 500) * 1.5;
    },
    ordersData() {
      if (this.items) {
        return this.items.map(item => item.count );
      }
      return [];
    },
    incomeData() {
      if (this.items) {
        return this.items.map(item => (item.totalPayments / 100) );
      }
      return [];
    },
    chart() {
      return {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            crossStyle: {
              color: "#999"
            }
          }
        },
        // toolbox: {
        //   feature: {
        //     dataView: { show: true, readOnly: false },
        //     magicType: { show: true, type: ["line", "bar"] },
        //     restore: { show: true },
        //     saveAsImage: { show: true }
        //   }
        // },
        legend: {
          data: ["השכרות", "הכנסות"]
        },
        xAxis: [
          {
            type: "category",
            data: this.xAxisData,
            axisPointer: {
              type: "shadow"
            }
          }
        ],
        yAxis: [
          {
            type: "value",
            name: "השכרות",
            // min: 0,
            // max: this.maxOrders,
            // interval: Math.floor(this.maxOrders / 5),
            axisLabel: {
              formatter: "{value}"
            }
          },
          {
            type: "value",
            name: "הכנסות",
            // min: 0,
            // max: this.maxIncome,
            // interval: Math.floor(this.maxIncome / 5),
            axisLabel: {
              formatter: "{value} ₪"
            }
          }
        ],
        series: [
          {
            name: "השכרות",
            type: "bar",
            data: this.ordersData
          },
          {
            name: "הכנסות",
            type: "line",
            yAxisIndex: 1,
            data: this.incomeData
          }
        ]
      };
    }
  },

  props: [],

  mounted() {
    this.fetchData();
  },

  components: {
    Card
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
